$(document).ready(function () {

	// halloween pages
	// if (window.location.href.indexOf('halloween-deals') > -1) {
	// 	$('body').addClass('halloween');
	// }

	//new V2 info-stripes / info-messages
	if ($(window).width() < 991) {
		if ($(".info-message--v2").length) {
			const isShopMessageClicked = getCookie("shop-message-clicked") === "true";

			$('.js-info-stripe-usp-item--shop-message--close').on("click", function () {
				handleHideShopMessage();
			});

			if (!isShopMessageClicked) {
				const shopMessageExists = $(".info-stripe-usp-item--shop-message").length > 0;

				// if (shopMessageExists) {
				// 	// Keep message 60 seconds, if ignored -> start rotation
				// 	setTimeout(() => {
				// 		handleHideShopMessage();
				// 	}, 60000);
				//
				// 	$(".js-info-stripe-usp-item-shop-message").on("click", function () {
				// 		handleHideShopMessage();
				// 	});
				// } else {
				// 	handleMobileInfoStripe();
				// }
				if (!shopMessageExists) {
					handleMobileInfoStripe();
				}
			} else {
				handleMobileInfoStripe();
				handleItemsVisibility();
			}

			function handleHideShopMessage() {
				// Set the cookie when the element is clicked
				setCookie("shop-message-clicked", "true", 20 / 1440);
				handleMobileInfoStripe();
				handleItemsVisibility();
			}

			function handleItemsVisibility() {
				$('.js-info-stripe-usp-item-0').addClass('d-none');
				$('.js-info-stripe-usp-item-0-replacer').removeClass('d-none');
			}

			function handleMobileInfoStripe() {
				const uspContainer = document.getElementsByClassName('info-stripe-usp')[0]; // Get first item with this class => [0]
				const uspElements = Array.from(uspContainer.children).filter(el => !$(el).is('.info-stripe-usp-item-0'));
				let currentIndex = 0;

				// CLS protection
				$('.info-stripe-usp-item').removeClass('d-none d-lg-block');

				function rotateUSPs() {
					uspElements.forEach(el => el.style.display = 'none');
					uspElements[currentIndex].style.display = 'block';
					currentIndex = (currentIndex + 1) % uspElements.length;
				}
				rotateUSPs();

				setInterval(rotateUSPs, 10000);
			}

			function setCookie(name, value, days) {
				const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
				document.cookie = name + "=" + value + "; expires=" + expires + "; path=/";
			}

			function getCookie(name) {
				const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
				return match ? match[2] : null; // Return `null` if the cookie doesn't exist
			}
		}
	}


    var dataShopLinkNormal = $('body').attr("data-shop_link_normal");

    var dataShopLinkMembership = $('body').attr("data-shop_link_membership");

    var dataShopLogin = $('body').attr("data-shop_login");

    var dataShopShoetype = $('body').attr("data-shop_shoetype");

    var dataShopWishList = $('body').attr("data-shop_wishlist");

    var dataContinue = $('.js-product-list-title-description').attr('data-continue');

	var $dn = 'd-none';
	var $d_lg_n = 'd-lg-none';
	var $_dn = '.d-none';


    //@layout
    document.documentElement.className = document.documentElement.className.replace('no-js', 'js');

    // if (!navigator.userAgent.indexOf('Safari') && navigator.userAgent.indexOf('Chrome')) {
    //     top4lazy.allElements().forEach(element => {
    //         $(element).removeClass('lazy')
    //     });
	//
    //     top4lazy.update();
    // }

    ProductGridListArrows();
    $(document).ready(function () {
        $('.toast-flash').toaster();
    });

    $(function () {
        $('[data-toggle="tooltip"]').tooltip()
    })
    $.nette.ext('history').cache = false;
    $('.top-toast-global').toast('show');


    //Product/detail-slides

    const images = document.querySelectorAll('.detail-slide');

    function handleIntersection(entries) {
        entries.map((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                [].forEach.call(document.getElementsByClassName('detail-slider-indicators__item'), function (el) {
                    el.classList.remove('is-active');
                });
                document.getElementById("_"+ entry.target.getAttribute('id')).classList.add('is-active');
            } else {
                entry.target.classList.remove('is-visible')
            }
        });
    }


    var optionsGallery2 = {
        root: document.querySelector('.detail-slides'),
        rootMargin: '0px',
        threshold: 0.5
    }

    const observerGallery = new IntersectionObserver(handleIntersection, optionsGallery2);

    images.forEach(image => observerGallery.observe(image));



    $('.detail-slider-button.is-right').click(function(e) {
        e.preventDefault();
        if($(".detail-slide.is-visible").next().is('.detail-slide')) {
            window.location.href = '#' + $(".detail-slide.is-visible").next().attr('id');
        }
        else {
            window.location.href = '#' + $(".detail-slide").first().attr('id');
        }
    });

    $('.detail-slider-button.is-left').click(function(e) {
        e.preventDefault();
        if($(".detail-slide.is-visible").prev().is('.detail-slide')) {
            window.location.href = '#' + $(".detail-slide.is-visible").prev().attr('id');
        }
        else {
            window.location.href = '#' + $(".detail-slide").last().attr('id');
        }
    });

    //User/loginmenu

    function modalSignIn() {
        // setFacebookStateNormal();
        $('.modal-login-container').removeClass('is-club');
        $('.modal-sign-in').addClass('show');
        $('.modal-sign-up').removeClass('show');
        $('.modal-sign-coupon').removeClass('show');
        $('.modal-sign-title').addClass('show');
    }

    function modalSignUp() {
        // setFacebookStateNormal();
        $('.modal-login-container').removeClass('is-club');
        $('.modal-sign-up').addClass('show');
        $('.modal-sign-in').removeClass('show');
        $('.modal-sign-coupon').removeClass('show');
        $('.modal-sign-title').addClass('show');
    }

    function modalCoupon() {
        $('.modal-login-container').removeClass('is-club');
        $('.modal-sign-in').addClass('show');
        $('.modal-sign-up').removeClass('show');
        $('.modal-sign-coupon').addClass('show');
        $('.modal-sign-title').removeClass('show');
    }

    function modalClub() {
        // setFacebookStateMembership();
        $('.modal-login-container').addClass('is-club');
        $('.modal-sign-in').addClass('show');
        $('.modal-sign-up').removeClass('show');
        $('.modal-sign-coupon').removeClass('show');
        $('.modal-sign-title').addClass('show');
    }

    function setFacebookStateNormal(){
        $.ajax({
            url: dataShopLinkNormal,
        method: 'POST',
            success: function(data)
        {
            if(data.ok) {
                $(".facebook-login-normal").attr("href", data.facebookLoginUrl);
            } else {
            }
        },
    });
    }
    function setFacebookStateMembership(){
        $.ajax({
            url: dataShopLinkMembership,
			method: 'POST',
				success: function(data)
			{
				if(data.ok) {
					$(".facebook-login-membership").attr("href", data.facebookLoginUrlMembership);
				} else {
				}
			},
		});
    }


	const $form = $("#login-form");


	$("#login-form").on('submit', function (e) {
		$('.modal-login-container').addClass('is-sending');
		const form_input = $(event.submitter);
		let type = form_input.attr("name");
		if (Nette.validateForm(this)) {
			var form = $form;
			$.ajax({
				url: dataShopLogin,
				method: 'POST',
				data: form.serialize() + "&type=" +type, // serializes the form's elements.
				success: function (data) {
					if (data.ok) {
						$('.modal-login-container').addClass('is-complete');
						setTimeout(function () {
							$('.modal-login-container').addClass('is-done');
						}, 500);
						if (data.register) {
							if (typeof (exponea) !== 'undefined') {
								exponea.track('registration', {
									email: data.email,
									registration_date: data.date
								})
							}
						}
						if (data.link) {
							window.location.href = data.link;
						} else {
							location.reload();
						}
					} else {
						$('.modal-login-alert').remove();
						$('#login-form').prepend('<div class="alert modal-login-alert alert-danger alert-dismissible collapse show" role="alert"><span>' + data.error + '</span><button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span> </button></div>')
						$('.modal-login-container').removeClass('is-sending is-complete');

						$('.js-modal-login-submit').prop("disabled", true);
						$('input', $form).on('input', function () {
							$('.js-modal-login-submit').prop("disabled", false);
						});
					}
				},
			});
		} else {
			$('.modal-login-container').removeClass('is-sending');
		}
		e.preventDefault();
	});


    $(".open-modal-login-in").click(function(){
        modalSignIn();
    });
    $(".open-modal-login-up").click(function(){
        modalSignUp();
    });

	//* we need to re-open coupon modal in basket/show after user logs-in from the "add-coupon" button/modal
		if ($('#basket_form').length > 0) {
			// "off" method to remove existing click event handlers before attaching a new one. Here’s how you can modify your code:
			$(".open-modal-login-coupon").click(function(){
				modalCoupon();

				if (!localStorage.getItem('basketCouponLogin')) {
					localStorage.setItem('basketCouponLogin', 'true');
					// console.log('setItem basketCouponLogin');
				}
			});

			if ($(".open-modal-coupon-logged-in").length > 0 && localStorage.getItem('basketCouponLogin') === 'true') {
				$('.open-modal-coupon-logged-in').click();
				// console.log('getItem basketCouponLogin');
			}

			$('.open-modal-coupon-logged-in').click(function() {
				removeLocalStorageItem();
			});

			// in case user exits the login modal before loggin-in, clear the localStorage handler
			$('#modal-login').find('[data-dismiss="modal"]').click(function() {
				removeLocalStorageItem();
			});

			// click handling for the modal underlay bg
			$('#modal-login').on('click', function(e) {
				if (e.target !== this) {
					// ignore clicks on child elements (basically only get the dismissing-modal click on underlay bg)
					return;
				}

				removeLocalStorageItem();
			});

			function removeLocalStorageItem() {
				if (localStorage.getItem('basketCouponLogin')) {
					localStorage.removeItem('basketCouponLogin');
					// console.log('removeItem basketCouponLogin');
				}
			}
		}
	//*

	$(".open-modal-login-club").click(function(){
        modalClub();
    });

    $(function() {
        if (location.hash === "#sign-in") {
            $('#modal-login').modal('show')
            modalSignIn();
        }
        if (location.hash === "#sign-up") {
            $('#modal-login').modal('show')
            modalSignUp();
        }
        if (location.hash === "#coupon") {
            $('#modal-login').modal('show')
            modalCoupon();
        }
        if (location.hash === "#club") {
            $('#modal-login').modal('show');
            modalClub();
        }
    });

    $('#modal-login').on('shown.bs.modal', function (e) {
        $('.modal-login-container').addClass('is-open');

        setTimeout(function () {
            $('.modal-login-membership-active').addClass('is-done');
        }, 1000);
    })

    $('#modal-login').on('hidden.bs.modal', function (e) {
        $('.modal-login-container').removeClass('is-sending is-complete is-done');
    })



    //Producer/default


    //components/MenuControl/default
  /*  $('.product-list-menu a').click(function(e) {
        $('#product-list').addClass('is-loading');
    });*/

    //components/PathControl/default.latte
    $('.breadcrumbs a').click(function(e) {
        $('#product-list').addClass('is-loading');
    });

    //@productList
	$('body').on('click', '.js-product-filter-toggle', function () { $('body').toggleClass('product-filter-opened'); });

    //components/ProductFitlterSummaryControl

    $('.product-list-remove-all').click(function(e) {
        $('#product-list').addClass('is-loading');
    });

    //components/ProductGridControll/default

    function isEllipsisActive(e) {
        return (e.offsetWidth < e.scrollWidth);
    }

    var elementList = document.querySelectorAll('.check-ellipsis');
    for (var idx = 0; idx < elementList.length; idx++) {
        if (isEllipsisActive(elementList.item(idx))) {
            elementList.item(idx).className = elementList.item(idx).className + " ellipsis-active"
            document.getElementsByClassName('product-list-title__description')[0].classList.add('is-hidden');
        }
    }

    $('#product-list').removeClass('is-loading');


	$('body').on('click', '.js-product-list-title-description', function () {
		$('.product-list-title__description').removeClass('is-hidden');
		$('.product-list-title__description').addClass('is-opened');
		$('.product-list-title__description-text').removeClass('check-ellipsis');
		$('.js-product-list-title-description-close').removeClass('hide');
	});

	$('body').on('click', '.js-product-list-title-description-close', function () {
		$('.js-product-list-title-description-close').addClass('hide');
		$('.product-list-title__description').removeClass('is-opened');
		$('.product-list-title__description').addClass('is-hidden');
		$('.product-list-title__description-text').addClass('check-ellipsis');
	});


	$( ".js-product-box-favorite" ).click(function(event) {
        event.preventDefault();
        $(this).toggleClass('is-active');
    });



    //components/ProductListControl/default

    $('.product-list-order-item').click(function (e) {
        $('#product-list').addClass('is-loading');
    });
    $('.product-list-dropdown-order-item').click(function (e) {
        $('#product-list').addClass('is-loading');
        $('.dropdown').dropdown('toggle')
    });

    //components/SearchModalControl/default

    var sizes = ["EU", "UK", "US", "CM"];
    $.each(sizes, function (key, value) {
        var shoetype = dataShopShoetype;
        if (shoetype === value) {
            $("." + value + "-sizes").show();
        } else {
            $("." + value + "-sizes").hide();
        }
    });

    //Basket/show

    $(".digital_service").click(function(e) {

        var id = '#' + $(this).find('input[type=checkbox]').attr('name');
        if($(this).find('input[type=checkbox]').is(":checked")) {
            var string_price = $(".js-order-price-total").html().replace(/\s/g, '').replace(/&nbsp;/g, '');
            var default_price = parseInt(string_price);
            var id_elem = '#price_digital_' + $(this).attr('id');
            var digital_price = parseInt($(id_elem).attr("data-price"));
            var sum_price = default_price - digital_price;
            $(".js-order-price-total").html(sum_price.toLocaleString());
            $(id).hide();
        } else {
            var string_price = $(".js-order-price-total").html().replace(/\s/g, '').replace(/&nbsp;/g, '');
            var default_price = parseInt(string_price);
            var id_elem = '#price_digital_' + $(this).attr('id');
            var digital_price = parseInt($(id_elem).attr("data-price"));
            var sum_price = default_price + digital_price;
            $(".js-order-price-total").text(sum_price.toLocaleString());
            $(id).show();
        }
    });

	$('.js-select-gift').each(function() {
		var $trigger = $(this).find('.js-select-gift-trigger');
		var $dropdown = $(this).find('.js-select-gift-dropdown');
		var $closeBtn = $(this).find('.js-select-gift-dropdown-close');
		var $overlay = $('.js-select-gift-dropdown-overlay');

		// base triggers/closers
		$trigger.click(function() {
			$('.js-select-gift-dropdown-step-2').addClass('collapse');
			$('.js-select-gift-dropdown-body-1').removeClass('collapse');

			$(this).addClass('active');
			$('.js-select-gift-dropdown').addClass('collapse');
			$dropdown.removeClass('collapse');
			$overlay.addClass('active');
		});

		function DropDownCloser(){
			// modal bodies handling
			$trigger.removeClass('active');
			$dropdown.addClass('collapse');
			$('.js-select-gift-dropdown-step-2').addClass('collapse');
			$('.js-select-gift-dropdown-body-1').removeClass('collapse');
			$('.js-select-gift-dropdown-step-2-size-btn').removeClass('active');

			// add-to-cart btn handling
			$('.js-select-gift-dropdown-step-2__add-gift-cart').addClass('disabled');
			$('.js-select-gift-dropdown-step-2__add-gift-cart__active').addClass($dn);
			$('.js-select-gift-dropdown-step-2__add-gift-cart__disabled').removeClass($dn);
			$overlay.removeClass('active');
		};

		$closeBtn.click(function() {
			DropDownCloser();
		});
		$overlay.click(function() {
			DropDownCloser();
		});
		$("[data-nogiftselect]").click(function() {
			DropDownCloser();
		});

		// gift select
		$("[data-giftselect]").click(function() {
			$(this).parent('.js-select-gift-dropdown-body-1').addClass('collapse');
			$($(this).attr('data-giftselect')).removeClass('collapse');

			var $currentlyViewedGiftSizes = $($(this).data('giftselect'));
			var $sizeButtons = $currentlyViewedGiftSizes.find('.js-select-gift-dropdown-step-2-size-btn');
			if ($sizeButtons.length === 1) {
				$sizeButtons.click();
			}
		});

		$('.js-select-gift-dropdown-step-2-size-btn').click(function(){
			var thisSize = $(this);
			var p = $(this).parent();
			$('.js-select-gift-dropdown-step-2-size-btn', p).removeClass('active');
			$(this).addClass('active');
			$("[data-addgift=" + $(this).data('productid') +"]").removeClass('disabled');

			$("[data-addgift=" + $(this).data('productid') +"]").attr('href', function(_, el){
				return el.replace(/(size=)[0-9]+/ig, '$1' + thisSize.data('sizeid'));
			});

			$('.js-select-gift-dropdown-step-2__add-gift-cart__disabled').addClass($dn);
			$('.js-select-gift-dropdown-step-2__add-gift-cart__active').removeClass($dn);
		});

		$("[data-addgift]").click(function() {
			if ( !$(this).hasClass('disabled') ) {
				var $targetName = 'promoGifts_' + $(this).data("target");
				var $targetValue = $(this).data('addgift');
				var $targetSizeName = 'promoGifts_' + $(this).data("target") + '_size';
				var $targetSizeValue = $('.js-select-gift-dropdown-step-2-size-btn.active').data('sizeid');
				var $targetGiftName = 'promoGifts_' + $(this).data("target") + '_giftId';
				var $targetGiftValue = $(this).data('giftid');

				$('input[name$='+ $targetName +']').val($targetValue);
				$('input[name$='+ $targetSizeName +']').val($targetSizeValue);
				$('input[name$='+ $targetGiftName +']').val($targetGiftValue);

				$trigger.removeClass('active');
				$dropdown.addClass('collapse');
				$overlay.removeClass('active');
				$('.js-select-gift-dropdown-body-1').removeClass('collapse');
				$('.js-select-gift-dropdown-step-2').addClass('collapse');
			}
		});

		$("#backtogiftselect[data-giftselect]").click(function() {
			$('.js-select-gift-dropdown-body-1').removeClass('collapse');
			$('.js-select-gift-dropdown-step-2').addClass('collapse');
		});
	});


    //Basket/wishlist

    $(".two-cols .basket-form .inp-text, .two-cols .inp-number-btn").change(function () {
        var itemcount = $(this).val();
        var itemid = $(this).attr("data-id");

        var jqxhr = $.ajax({
            method: "POST",
            url: dataShopWishList,
        data: {"itemid": itemid, "itemcount": itemcount}
    })
    .done(function (data) {
            $("#ajaxmess_" + itemid).html(data.message);
            if (data.status == 1) {
                $("#ajaxmess_" + itemid).css('color', 'green');
            }
            else {
                $("#ajaxmess_" + itemid).css('color', 'red');
            }
            $("#ajaxmess_" + itemid).css('display', 'block');
        })
    });

    //Category/banners2

    $('.category-producer-banner h1 + p').nextUntil("div").addBack().wrapAll('<div class="product-list-title__description is-hidden" />').wrapAll('<div class="product-list-title__description-text check-ellipsis" />');
    $('<a href="javascript:" class="js-product-list-title-description link-underline color-gray ml-2">' + dataContinue + '</a>').appendTo().one('.product-list-title__description');
    $(window).on("resize", function () {
        function isEllipsisActive(e) {
            return (e.offsetWidth < e.scrollWidth);
        }

		var elementList = document.getElementsByClassName('.check-ellipsis');
		if (!$(elementList).hasClass('ellipsis-active')) {
			for (var idx = 0; idx < elementList.length; idx++) {
				if (isEllipsisActive(elementList.item(idx))) {
					elementList.item(idx).className = elementList.item(idx).className + " ellipsis-active"
					document.getElementsByClassName('product-list-title__description')[0].classList.add('is-hidden');
					// console.log(elementList.item(idx), elementList.item(idx).className);
				}
			}
		}
    }).resize();

    //Error/some

    $(".adminmenu").show();

    //Faq/faq

    function callFilterAjax(url, data) {
        $.nette.ajax({
            url: url,
            data: data
        });
    }

    $(".faq-search-inp").on('keyup', function () {
        callFilterAjax($(this).data('url'), {"txt": $(this).val()});
    });

    //Home/hp-promo_type_2
    document.addEventListener("fullscreenchange", function () {
        var tempH = 0;
        var h0 = document.getElementById("promo-0").style.width;
        var h1 = document.getElementById("promo-2").style.width;

        for (let i = 0; i < 6; i++) {
            if (i < 3) {
                tempH = h0;
            } else {
                tempH = h1;
            }
            document.getElementById("promo-" + i).style.height = tempH + "px";
        }
    });

    //Home/swiper

    $(".carousel-homepage").each(function (index, element) {
        var $this = $(this);
        $this.attr("id", "carousel-homepage-" + index);
        $this.find(".carousel-next").attr("href", "#carousel-homepage-" + index);
        $this.find(".carousel-prev").attr("href", "#carousel-homepage-" + index);
        $this.find(".carousel-pagination-bullet").attr("data-target", "#carousel-homepage-" + index)

        $('#carousel-homepage-' + index).carousel({

        }).on('slid.bs.carousel', function () {
            if ($('#carousel-homepage-' + index + ' .carousel-item.active').hasClass('black')) {
                $('#carousel-homepage-' + index).addClass('black')
            } else {
                $('#carousel-homepage-' + index).removeClass('black')
            }
        });

		// 	.on('slide.bs.carousel', function () {
        //     if (!navigator.userAgent.indexOf('Safari') && navigator.userAgent.indexOf('Chrome')) {
        //         top4lazy.allElements().forEach(element => {
        //             $(element).removeClass('lazy')
        //         });
		//
        //         top4lazy.update();
        //     }
        // })
		/*.swipe({
                    swipe: function(event, direction, distance, duration, fingerCount, fingerData) {
                        if (direction == 'left') $(this).carousel('next');
                        if (direction == 'right') $(this).carousel('prev');
                    },
                    allowPageScroll:"vertical"
                })*/
		// ;

        $('#carousel-homepage- ' + index + ' .carousel-item a').click(function() { window.location.href = $(this).attr("href"); });
    });

    //Order/blikPrzelewy24

    document.addEventListener('DOMContentLoaded', function () {
        function setInputFilter(textbox, inputFilter) {
            ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function(event) {
                textbox.addEventListener(event, function() {
                    if (inputFilter(this.value)) {
                        this.oldValue = this.value;
                        this.oldSelectionStart = this.selectionStart;
                        this.oldSelectionEnd = this.selectionEnd;
                    } else if (this.hasOwnProperty("oldValue")) {
                        this.value = this.oldValue;
                        this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
                    } else {
                        this.value = "";
                    }
                });
            });
        }

        setInputFilter(document.getElementById("blik-code"), function(value) {
            return /^\d*\d*$/.test(value);
        });
    });

    //Order/teamOrderDelivery

    $(".buttons .next-step").click(function () {
        $("#send_button").click();
        return false;
    });

    //Page/contest

    $("input[name=rspn]").val(5);
    $("input[name=rspn]").hide();
    $(".rspn").hide();

    //Page/fortuna

    $(document).ready(function(e) {
        setDresType($('#frm-fortunaContestForm-dresType').val());
    });

    $('#frm-fortunaContestForm-dresType').change(function() {
        var el = $(this);
        setDresType(el.val());
    });

    function setDresType(type) {
        $('#frm-fortunaContestForm-dresSize option').hide();
		$('#frm-fortunaContestForm-dresSize option').prop('disabled', true);
        $("#frm-fortunaContestForm-dresSize option[value^=" + type + "]").show();
		$("#frm-fortunaContestForm-dresSize option[value^=" + type + "]").prop('disabled', false);
        $("#frm-fortunaContestForm-dresSize").val($("#frm-fortunaContestForm-dresSize option[value^=" + type + "]:first").val());
    }

    //Page/read

    $('.article-content-image--fullWidth').each(function() {
        $(this).parent(':not(article)').addClass('article-content-fullWidth');
    });

    $(document).ready(function () {
        let token = "1083659548807676|6b0c1e8ec5f4a25abe3ab1d072e75fc2";
        $('[data-instagram]').each(function() {
            var this_ig_element = $(this);
            var this_ig = $(this).attr('data-instagram');
            $.ajax({
                type: 'GET',
                url: 'https://graph.facebook.com/v9.0/instagram_oembed?url=https://www.instagram.com/p/' + this_ig + "&access_token=" + token,
                dataType: 'json',
                success: function (data) {
                    $(this_ig_element).html(data['html']);
                }
            });
        });
    });

    $(document).ready(function () {
        /*JQUERY PRO SWIPER BLOG */

        /* oprava starych carouselu do dne 8.8.2019 */

        /* JQUERY PRO WRAPOVANI IFRAME NA YOUTUBE VIDEA */

        $('.carousel-control-prev-icon i').remove();
        $('.carousel-control-next-icon i').remove();

        $(document).on('click', '[data-toggle="lightbox"]', function(event) {
            event.preventDefault();
            $(this).ekkoLightbox();
        });

		$(".swiper-blog").each(function (index, element) {
			var $this = $(this);
			$this.addClass("carousel slide carousel-control instance-" + index).attr("data-interval", "false");
			$this.attr("id", "carousel-blog-" + index);
			$this.find(".swiper-wrapper").addClass("carousel-inner").removeClass("swiper-wrapper");
			$this.find(".swiper-slide:first").addClass("active");
			$this.find(".swiper-slide").addClass("carousel-item").removeClass("swiper-slide");

			$this.find(".swiper-pagination").addClass("pagination-" + index).removeClass("swiper-pagination");
			$this.find(".swiper-next").addClass("carousel-control-next").attr("data-slide", "next").attr("href", "#carousel-blog-" + index).removeClass("swiper-next swiper-navigation").html('<span class="carousel-control-next-arrow" aria-hidden="true"></span>');
			$this.find(".swiper-prev").addClass("carousel-control-prev").attr("data-slide", "prev").attr("href", "#carousel-blog-" + index).removeClass("swiper-prev swiper-navigation").html('<span class="carousel-control-prev-arrow" aria-hidden="true"></span>');

			$this.removeClass("swiper-blog swiper-container");
			$('#carousel-blog-' + index).carousel();
		});

    });


    //Page/styleguide

    function rgb2hex(rgb){
        rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
        return (rgb && rgb.length === 4) ? "#" +
            ("0" + parseInt(rgb[1],10).toString(16)).slice(-2) +
            ("0" + parseInt(rgb[2],10).toString(16)).slice(-2) +
            ("0" + parseInt(rgb[3],10).toString(16)).slice(-2) : '';
    }

    $('#take-body_color').find('.cards-image-cover').css('background-color', rgb2hex($('body').css('color')));


    //Product/ajax-detail-gifts

    $(function () {
        $('[data-toggle="popover"]').popover('update')
    })

    //Product/detail-gift

    $(function () {
        $('.detail-popover-gift').popover({
            trigger: 'hover',
            html: true,
            template: '<div class="popover detail-popover-gift-tooltip box-shadow" role="tooltip"><div class="arrow"></div><div class="popover-header"></div><div class="popover-body"></div></div>'
        });
    })

    //Product/read

    $('.is-gallery-hidden').on('show.bs.collapse', function () {
        $('body').addClass('is-fixed');
    })
    $('.is-gallery-hidden').on('shown.bs.collapse', function () {
        $('body').removeClass('is-fixed');
    })

    $('.is-gallery-hidden').on('hidden.bs.collapse', function () {
        $(window).scrollTop(0);
    })

    $(".js-modal-login-membership").on('click', function (){
        $("#login-form #redirect_input").attr('value', 'membership-product');
    })

    //Search/search

    $(document).ready(function () {
        $(".showmore").hide();
        $(".showmore.master").show();
        $('.showmore.master').on('click', function () {
            var c = $(this);
            $('.showmore').each(function () {
                $(this).show("fast");
                c.hide();
                expand_t = true;
            });
        });
    });

    //Store/visit

    $(document).ready(function(){
        $(".okbuy").hide();
        $(".nobuy").hide();

        $(".buy").change(function(){
            $(".nobuy").hide();
            $(".okbuy").hide();
            if($(this).val() == 1){
                $(".okbuy").show();
            } else if ($(this).val() == 0){
                $(".nobuy").show();
            }
        });

        if( $(".date_input").length > 0){

            $(".date_input").pickadate({
                format:'d.m.yyyy',
                firstDay:1,
                editable:true
            });
            /*
            $('.time_picker').pickatime({
                interval: 5,
                min: [9,0],
                max: [19,0],
            });
*/
        }
    });

    //Test/layout

    document.body.className+=' js'


    //User/discount

    $('.discount-body').on('hide.bs.collapse', function () {
        $(this).closest('.discount-item').removeClass('is-open');
    });
    $('.discount-body').on('show.bs.collapse', function () {
        $(this).closest('.discount-item').addClass('is-open');
    });

    $("#discount-" + location.hash.substr(1)).addClass('from-hash');
    $("#discount-detail-" + location.hash.substr(1)).collapse('show');

    //User/membership

    $(function() {
        setTimeout(function () {
            $('.membership-container').addClass('is-done');
        }, 1000);
    });

    //User/newReclamation

    var products = ['test'];
    $(document).ready(function () {
        $('.custom-file input').on('change', function() {
            let files = [];
            for (let i = 0; i < $(this)[0].files.length; i++) {
                files.push($(this)[0].files[i].name);
            }

            $('.custom-file-label').text(files.join(', '));
        });

        $("#auto-id-products").keyup(function () {
            product = $(this).val();
            var jqxhr = $.ajax({
                url: "./get-product-id",
                data: {"product": product}
            })
                .done(function (data) {
                    if (data.error) {
                        return false
                    }
                    if (data.product) {
                        //console.log(data.product);
                        products = data.product;
                        autocomplete($("#auto-id-products"), products);
                    }
                })

                .fail(function (e) {

                    //alert(e.status + e.responseText);
                });
        });


        function autocomplete(inp, arr) {
            var currentFocus;

            var a, b, i, val = inp.val();
            id = val;

            closeAllLists();
            if (!val) {
                return false;
            }
            currentFocus = -1;
            a = document.createElement("DIV");
            a.setAttribute("id", id + "autocomplete-list");
            a.setAttribute("class", "autocomplete-items");
            inp.parent().append(a);
            for (i = 0; i < arr.length; i++) {
                if (arr[i].substr(0, val.length).toUpperCase() == val.toUpperCase()) {
                    b = document.createElement("DIV");
                    b.innerHTML = "<strong>" + arr[i].substr(0, val.length) + "</strong>";
                    b.innerHTML += arr[i].substr(val.length);
                    b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
                    b.addEventListener("click", function (e) {
                        inp.val(this.getElementsByTagName("input")[0].value);
                        closeAllLists();
                    });
                    a.appendChild(b);
                }
            }

            inp.keydown(function (e) {
                var x = $(id + "autocomplete-list");
                if (x) x = x.find("div");
                if (e.keyCode == 40) {
                    currentFocus++;
                    addActive(x);
                } else if (e.keyCode == 38) {
                    currentFocus--;
                    addActive(x);
                } else if (e.keyCode == 13) {
                    e.preventDefault();
                    if (currentFocus > -1) {
                        if (x) x[currentFocus].click();
                    }
                }
            });

            function addActive(x) {
                if (!x) return false;
                removeActive(x);
                if (currentFocus >= x.length) currentFocus = 0;
                if (currentFocus < 0) currentFocus = (x.length - 1);
                x[currentFocus].classList.add("autocomplete-active");
            }

            function removeActive(x) {
                for (var i = 0; i < x.length; i++) {
                    x[i].classList.remove("autocomplete-active");
                }
            }

            function closeAllLists(elmnt) {
                var x = $(".autocomplete-items");
                for (var i = 0; i < x.length; i++) {
                    if (elmnt != x[i] && elmnt != inp) {
                        x[i].parentNode.removeChild(x[i]);
                    }
                }
            }

            document.addEventListener("click", function (e) {
                closeAllLists(e.target);
            });
        }

        //autocomplete($("#auto-id-products"), products);

    });

    $("#email-reclamation").addClass('disabled-input');
    $("#email-reclamation").prop('readonly', true);


    //user/userform + order/delivery + basket/show
	$(document).ready(function () {
		$(".js-checkbox-collapse").each(function (e) {
			var this_target = $(this).attr('data-href');
			$check = $(this).find('input[type="checkbox"]');
			if ($check.prop('checked')) {
				$(this_target).collapse('show');
			}
		});

		$(".js-checkbox-collapse").click(function (e) {
			if ($(this).hasClass("js-checkbox-collapse--partnerDisabled")) {
				return;
			}

			e.preventDefault();
			var this_target = $(this).attr('data-href');
			var $this_click = $(e.target);

			$check = $(this).find('input[type="checkbox"]');
			if ($check.prop('checked')) {
				if (!$this_click.data('lockedAt') || +new Date() - $this_click.data('lockedAt') > 300) {
					$(this_target).collapse('hide');
					$check.prop("checked", false);
				}
				$this_click.data('lockedAt', +new Date());

			} else {
				if (!$this_click.data('lockedAt') || +new Date() - $this_click.data('lockedAt') > 300) {
					$(this_target).collapse('show');
					$check.prop("checked", true);
				}
				$this_click.data('lockedAt', +new Date());
			}
		});
	});

    //popup

    $(document).ready(function () {
        if (window.location.hash == "#openPopup") {
            $('#popup-modal').modal('show');
        } else {
            var hash = window.location.hash.substr(1);
            if(hash) {
                var result = hash.split('&').reduce(function (result, item) {
                    var parts = item.split('='); result[parts[0]] = parts[1];
                    return result;
                }, {});
                if(result.hasOwnProperty("popup")){
                    var sec = parseFloat(result.popup);
                    if(!sec){ sec = 10;}
                    setTimeout(function () {
                        $('#popup-modal').modal('show');
                    }, 1000 * sec);
                }
            }
        }
    });


    $(document).ready(function () {

		//popup-eleven
        var popup_eleven = 0;
        if (window.location.hash == "#rebrand") {
            popup_eleven = setTimeout(function () {
                $('#popup-eleven').modal('show');
                var date = new Date();
                date.setFullYear(date.getFullYear() + 10);
                document.cookie = 'rebrand=1; path=/; expires=' + date.toGMTString();
                dataLayer = [{
                    'event': 'ga.event',
                    'eventCategory': 'Popup_rebrand',
                    'eventAction': 'Show',
                    'eventLabel': window.location.href,
                    'eventNoninteraction': true
                }];
            }, 2000);
        }

        $(document).on('show.bs.modal', '.modal', function () {
            clearTimeout(popup_eleven);
        });

        // onclick data layer
        $("#popup-modal-close").on("click", function () {
            dataLayer = [{
                'event': 'ga.event',
                'eventCategory': 'Popup_rebrand',
                'eventAction': 'Confirm',
                'eventLabel': window.location.href,
                'eventNoninteraction': true
            }];
        });

        $('#popup-eleven').on('hide.bs.modal', function (e) {
            dataLayer = [{
                'event': 'ga.event',
                'eventCategory': 'Popup_rebrand',
                'eventAction': 'Close',
                'eventLabel': window.location.href,
                'eventNoninteraction': true
            }];
        })

		// popup weplayhandball HR rebrand
		if ($('#handball-hr-rebrand').length) {
			const urlParams = new URLSearchParams(window.location.search);
			const isFromHrRedirect = urlParams.get('utm_source') === 'hdhr' &&
				urlParams.get('utm_medium') === 'redirect';

			if (isFromHrRedirect) {
				$('#handball-hr-rebrand').modal('show');
			}
		}

		// popup country selection
		// if ($('#country-selection-popup').length) {
		// 	const trigger = $(".js-country-select-international-shop");
		// 	const countrySelectionStatus = sessionStorage.getItem("country_selected");
		//
		// 	trigger.on("click", function() {
		// 		sessionStorage.setItem("country_selected", true);
		// 	});
		//
		// 	if (!countrySelectionStatus) {
		// 		console.log('country-selection');
		// 		$('#country-selection').modal('show');
		// 	}
		// }
    });

	// restoring top-filters active tab on reload (a.k.a. on filter selection)
		// if (!window.topFiltersInitialized) { //prevents from running more than once after reload
		// 	window.topFiltersInitialized = true;
		//
		// 	if ($(".js-top-filter").length) {
		// 		const tabLinks = $(".top-filters-nav-link");
		// 		const activeTabId = localStorage.getItem("activeTabId");
		//
		// 		tabLinks.on("click", function() {
		// 			localStorage.setItem("activeTabId", this.id);
		// 		});
		// 		if (activeTabId) {
		// 			const activeTab = $("#" + activeTabId);
		// 			const currentActiveTabId = $(".top-filters-nav-link.active").attr("id");
		// 			if (activeTab.length > 0 && activeTabId !== currentActiveTabId) {
		// 				activeTab.trigger("click");
		// 			}
		// 		}
		// 	}
		// }


	// v2filters & active-filters wrapping handling
		/**
			* @typedef {Object} DetectWrapOptions
			* @property {string} className - The class name of the items to detect wrapping.
			* @property {boolean} [byPosition=true] - Toggle to choose position-based or width-based detection.
			* @property {string|null} [itemSelector=null] - Selector for the items (used in width-based detection).
			* @property {string|null} [containerSelector=null] - Selector for the container (used in width-based detection).
			* @property {string|null} [btnSelector=null] - Selector for the button (used in width-based detection).
			* @property {string|null} [counterSelector=null] - Selector for the counter element.
		*/

		/**
			* Detects wrapped items based on position or width.
			* @param {DetectWrapOptions} options - The options for detecting wrapped items.
			* @returns {Array} - The indices of wrapped items.
		*/
		var detectWrap = function({
			className,
			byPosition = true, // Toggle to choose position-based or width-based detection
			itemSelector = null,
			containerSelector = null,
			btnSelector = null,
			counterSelector = null, // Add counterSelector to detect itemsCounter
		  }) {
			var wrappedItems = [];
			var prevItem = {};
			var currItem = {};
			var items = $('.' + className);

			// If detecting based on position (default behavior)
			if (byPosition) {
				items.each(function(i, item) {
					currItem = $(item)[0].getBoundingClientRect();
					if (prevItem && prevItem.top < currItem.top) {
						wrappedItems.push(i);
					}
					prevItem = currItem;
				});

				// Check if itemsCounter is wrapping into a second row
				if (counterSelector && $(counterSelector).length) {
					var counter = $(counterSelector)[0].getBoundingClientRect();
					var firstItem = items.first()[0].getBoundingClientRect();
					if (counter.top > firstItem.top) {
						// Hide one more item to prevent itemsCounter from wrapping
						wrappedItems.push(wrappedItems.length);
					}
				}
			} else if (itemSelector && containerSelector && btnSelector) {
				// If detecting based on container width
				var itemWidth = $(itemSelector).outerWidth(true); // Width of each item
				var containerWidth = $(containerSelector).outerWidth();
				var itemsToShow = Math.floor((containerWidth - $(btnSelector).outerWidth(true)) / itemWidth);

				// Reset item visibility
				$(itemSelector).removeClass($dn);

				// Hide items beyond the count that can fit in the row
				for (var i = itemsToShow; i < $(itemSelector).length; i++) {
					$($(itemSelector)[i]).addClass($dn);
					wrappedItems.push($(itemSelector)[i]);
				}

				// Check if itemsCounter is wrapping into a second row
				if (counterSelector && $(counterSelector).length) {
					var counter = $(counterSelector)[0].getBoundingClientRect();
					var firstItem = $(itemSelector).first()[0].getBoundingClientRect();
					if (counter.top > firstItem.top) {
						// Hide one more item to prevent itemsCounter from wrapping
						$($(itemSelector)[itemsToShow - 1]).addClass($dn);
						wrappedItems.push($(itemSelector)[itemsToShow - 1]);
					}
				}
			}

			return wrappedItems;
		};

		$(document).ready(function () {
			initializeFilterHandling();
		});
		function initializeFilterHandling() {
			let showLess = $('.filter-sticker-handler-show-less');
			let items = $('.filter-sticker-item');
			let itemsCounter = $('.filter-sticker-counter');
			let itemsCounterContent = $('.js-filter-sticker-counter');
			let currentCount = itemsCounterContent.data('count') || 0;

			if (!window.filtersInitialized) {
				window.filtersInitialized = true;

				$(window).on('load', function () {
					if ($(window).width() < 991) {
						handleFiltersWrap();
					}
				});

				// re-arrange filters after ajax call
				$(document).ajaxComplete(function (event, xhr, settings) {
					if (settings.filtersAjax) { //filtersAjax defined inline in filters
						//don't move these, we need to get them on each click in case ajax changed things up
						showLess = $('.filter-sticker-handler-show-less');
						items = $('.filter-sticker-item');
						itemsCounter = $('.filter-sticker-counter');
						itemsCounterContent = $('.js-filter-sticker-counter');
						currentCount = itemsCounterContent.data('count') || 0;

						handleFiltersWrap();
					}
				});

				var initialWidth = $(window).width();
				$(window).on('resize', function () {
					if ($(window).width() < 991) {
						var currentWidth = $(window).width();
						if (initialWidth !== currentWidth) {
							initialWidth = currentWidth;
							handleFiltersWrap();
						}
					}
				});

				$('body').on('click', '.filter-sticker-handler-show-less', function () {
					handleFiltersWrap();
					$(this).addClass($dn);
				});

				$('body').on('click', '.filter-sticker-counter', function () {
					itemsCounter.addClass($dn);
					items.removeClass($dn);
					currentCount = 0;

					// check if items need to be wrapped again after screen resize
					let localItemsReCount = 0;
					$.each(detectWrap({
						className: 'filter-sticker-item',
						byPosition: true
					}), function (k, wrappedIndex) {
						localItemsReCount += items.slice(wrappedIndex).not($_dn).length;
					});
					if (localItemsReCount > 0) {
						showLess.removeClass($dn);
					}
				});

				function handleFiltersWrap() {
					// Don't move these, we need to get them on each click in case ajax changed things up
					showLess = $('.filter-sticker-handler-show-less');
					items = $('.filter-sticker-item');
					itemsCounter = $('.filter-sticker-counter');
					itemsCounterContent = $('.js-filter-sticker-counter');
					var hiddenCount = 0;

					$.each(detectWrap({
						className: 'filter-sticker-item',
						byPosition: true,
						counterSelector: '.filter-sticker-counter',
					}), function(k, wrappedIndex) {
						hiddenCount += items.slice(wrappedIndex).not($_dn).addClass($dn).length;
					});

					currentCount += hiddenCount;
					if (currentCount > 0) {
						showLess.addClass($dn);
						$('.filter-sticker-handler').add(itemsCounter).removeClass($dn);
						itemsCounterContent.data('count', currentCount);
						itemsCounterContent.html("+" + currentCount);
					}
				}
			}
		}

		if ($(".js-product-filter-wrap--v2").length) {
			var showAllV2selector = '.js-product-filter-item-trigger--show-all'
			var showLessV2selector = '.js-product-filter-item-trigger--show-less'

			var showAllV2 = $(showAllV2selector);
			var showLessV2 = $(showLessV2selector);
			var $pf = '.product-filter';

			if ($(window).width() > 991) {
				$('body').on('click', showAllV2selector, function () {
					//don't move these, we need to get them on each click in case ajax changed things up
					let itemV2 = $($pf);
					let showAllV2 = $(showAllV2selector);
					let showLessV2 = $(showLessV2selector);

					itemV2.removeClass($d_lg_n);
					showAllV2.addClass($dn);
					showLessV2.removeClass($dn);

					getLastProductFilterInRowBeforeWrap();
				});

				$('body').on('click', showLessV2selector, function () {
					//don't move these, we need to get them on each click in case ajax changed things up
					let itemV2 = $($pf);
					let showAllV2 = $(showAllV2selector);
					let showLessV2 = $(showLessV2selector);

					var itemWidth = itemV2.outerWidth(true);
					var containerWidth = $('.js-product-filter-wrap--v2').outerWidth();
					var itemsToShow = Math.floor((containerWidth - showAllV2.outerWidth(true)) / itemWidth) - 2; // -2 instead of -1 to be sure we are not wrapping the trigger buttons or overflowing

					itemV2.each(function(i) {
						if (i < itemsToShow) {
							$(this).removeClass($d_lg_n);
						} else {
							$(this).addClass($d_lg_n);
						}
					});

					showLessV2.addClass($dn);
					showAllV2.removeClass($dn);
				});
			}

			function initializeV2Filters() {
				var hasWrappedItems = detectWrap({
					className: 'product-filter',
					byPosition: false,
					itemSelector: $pf,
					containerSelector: '.js-product-filter-wrap--v2',
					btnSelector: showAllV2
				});

				if (hasWrappedItems.length) {
					showAllV2.removeClass($dn);
					showLessV2.addClass($dn);
				} else {
					showAllV2.addClass($dn);
					showLessV2.addClass($dn);
				}
			}

			function getLastProductFilterInRowBeforeWrap() {
				let lastOffsetTop = null;
				let $lastInRow = null;
				let $secondLastInRow = null;
				let $items = $('.js-product-filter-wrap--v2 .product-filter:visible'); // Only visible filters

				$items.removeClass('first-in-row detail-box-right-0').each(function (index) {
						let $current = $(this);
						let currentOffsetTop = $current.offset().top;

						// If row changes, mark this item as first in row
						if (lastOffsetTop !== null && currentOffsetTop !== lastOffsetTop) {
							$current.addClass('first-in-row');
						}

						// First element is always first in row
						if (index === 0) {
							$current.addClass('first-in-row');
						}

						if (lastOffsetTop !== null && currentOffsetTop !== lastOffsetTop) {
							$secondLastInRow.addClass('detail-box-right-0');
							$lastInRow.addClass('detail-box-right-0');
						}

						$secondLastInRow = $lastInRow;
						$lastInRow = $current;
						lastOffsetTop = currentOffsetTop;
					});

				$secondLastInRow.addClass('detail-box-right-0');
				$lastInRow.addClass('detail-box-right-0');
			}

			$(window).on('load', function() {
				if ($(window).width() < 991) {
					$($pf).removeClass($d_lg_n);
				}
			});
			$(window).on('resize', function() {
				if ($(window).width() > 991) {
					initializeV2Filters();
				}
				$($pf).removeClass($d_lg_n);
			});
		}

		// handling mobile default-shown filter-shortcuts to go straight to content/detail
		$('body').on('click', '.product-filter-item-trigger-mob-default-btn', function () {
			if (!$(this).hasClass('product-filter-item-trigger-mob-default-btn--show-all')) {
				let triggerId = $(this).attr('class').match(/js-product-filter-item-trigger--([^\s]+)/)[1];
				let productFilterBodyV2 = $('.js-product-filter-item-content--' + triggerId);

				if (productFilterBodyV2.hasClass('hidden')) {
					$('.product-filter-item-content').not('.hidden').addClass('hidden');
					productFilterBodyV2.removeClass('hidden');
				} else {
					productFilterBodyV2.addClass('hidden');
				}
			}
		});
	// -- end -- v2filters & active-filters wrapping handling

	$('#miami_calling_socials-close').on('click', function (event) {
		event.stopPropagation()

		const modal = $('#miami_calling_socials')
		modal.removeAttr('style') // Remove inline styles
		modal.removeClass('show') // Remove Bootstrap's 'show' class
		modal.attr('aria-modal', 'false') // Set aria-modal to false
		modal.attr('aria-hidden', 'true') // Ensure it's marked as hidden for accessibility

		// Remove the Bootstrap backdrop (if it exists)
		$('.modal-backdrop:last').remove()
	})
});


/**
 * Google trust show/hide after scroll
 */
$(window).scroll(function() {
	var scrollTop = $(this).scrollTop();
	if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
		if (scrollTop > 50) {
			$('.google-trust-box').fadeOut();
		} else {
			$('.google-trust-box').fadeIn();
		}
	}
});

// for non-pdp sidebar loads
$("[data-sidebar]").click(function() {
	$($(this).attr('data-sidebar')).toggleClass('is-show');
	$('body').toggleClass('is-fixed');
});

function copyHiddenInputToClipboardWithConfirmationSvg(id, index) {
	var copyText = $("#" + id);
	var temporaryTextarea = $("<textarea>").val(copyText.val());
	$("body").append(temporaryTextarea);
	temporaryTextarea.select();
	document.execCommand("copy");
	temporaryTextarea.remove();

	var svgElement = $('<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 15 15">' +
		'<path d="M14.5 7.5C14.5 11.366 11.366 14.5 7.5 14.5C3.63401 14.5 0.5 11.366 0.5 7.5C0.5 3.63401 3.63401 0.5 7.5 0.5C11.366 0.5 14.5 3.63401 14.5 7.5ZM11.0265 4.84846C10.7703 4.59218 10.3547 4.59218 10.0985 4.84846C10.0923 4.85465 10.0865 4.86121 10.081 4.86809L7.04272 8.73965L5.21089 6.90782C4.95461 6.65154 4.5391 6.65154 4.28281 6.90782C4.02653 7.1641 4.02653 7.57962 4.28281 7.8359L6.59846 10.1515C6.85474 10.4078 7.27025 10.4078 7.52653 10.1515C7.53224 10.1458 7.53763 10.1398 7.54267 10.1335L11.0358 5.76704C11.2828 5.51009 11.2797 5.1016 11.0265 4.84846Z" fill="white"></path>' +
		'</svg>'
	);

	var buttonElement = $('#copyHiddenInputToClipboardButton-' + index);
	var svgAppended = buttonElement.data('svgAppended');

	if (buttonElement.length && !svgAppended) {
		buttonElement.append(svgElement);
		buttonElement.data('svgAppended', true);

		setTimeout(function () {
			svgElement.remove();
			buttonElement.removeData('svgAppended');
		}, 5000);
	}
}

//moved from product.js
var obj;
$(".js-detail-page-ajax").on('click', function (e) {
	var page = $(this).attr("data-url");
	var page_id = $(this).attr("data-page-url");
	var type = $(this).attr("data-getmodal-type");
	var str = getModal(page_id, type);
	obj = $(str).modal('show');
	/*obj.open();*/
	$.ajax({
		url: "../pg/" + page
	}).done(function (payload) {
		if (payload) {
			var muj_payload = $.parseHTML(payload);
			var $rtable_list = '<hr><ul>';

			$(muj_payload).find('.rtable-wrap h5').each(function(i) {
				$(this).attr('id', 'rtable--'+i );
				$rtable_list += '<li><a href="#rtable--'+i+'">' + $(this).text(); +'</a></li>';
			});
			$rtable_list += '</ul><hr>';

			$(muj_payload).find('.rtable-wrap h2').after($rtable_list);
			$(muj_payload).find('.rtable-wrap h2').replaceWith(function () {
				return "<h4>" + $(this).html() + "</h4>";
			});

			var inst = $(str).find('.modal-paste-content').addClass('modal-content').html(muj_payload);

		} else {
		}
		dataLayer.push({
			'event':'ga.event', 'eventCategory': 'PDP',
			'eventAction': 'Size_chart', 'eventLabel': location.href,
			'eventNoninteraction': true
		});
	}).fail(function () {
	});
	e.preventDefault();
});
